import uuid from "uuid/v4";
import { axiosProxy } from "utils/axiosProxy";
import { actionTypes } from "constants/Reports/harvest/pickerReport";
import { omitBy, isNil } from "lodash";
const url = "/reporting_module/generalBarcodes/pickerReport";
const url1 = "/reporting_module/packedBoxes/pickerReport";

let uniqId;

export const fetchPickerReportTableData = ({
  page,
  size,
  search,
  sort = ["id,desc"],
  unpaged = false,
  filters
}) => async dispatch => {
  try {
    dispatch({ type: actionTypes.FETCH_PICKER_REPORT_TABLE_DATA_START });
    const paramsObject = omitBy(
      {
        search,
        sort,
        page,
        size
      },
      isNil
    );
    const params = new URLSearchParams(paramsObject);

    if (Array.isArray(filters)) {
      filters.forEach(([filter, value]) => {
        const from = value.slice(0, 10);
        const to = value.slice(-10);
        return filter !== "seasons"
          ? params.append(filter, value)
          : (params.append("from", `${from}T00:00:00`),
            params.append("to", `${to}T23:59:59`));
      });
    }
    uniqId = uuid();
    const res = await axiosProxy({
      method: "GET",
      params,
      uniqId,
      url: `${url}`
    });
    if (uniqId === res.config.headers["X-REQUEST-ID"]) {
      dispatch({
        type: actionTypes.FETCH_PICKER_REPORT_TABLE_DATA,
        payload: res.data
      });
    }
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_PICKER_REPORT_TABLE_DATA_FAILED,
      payload: error
    });
  }
};

export const fetchPickerReportExportData = ({
  unpaged = true,
  filters
}) => async dispatch => {
  try {
    dispatch({
      type: actionTypes.FETCH_PICKER_REPORT_TABLE_LIST_START
    });
    const paramsObject = omitBy(
      {
        unpaged: true
      },
      isNil
    );
    const params = new URLSearchParams(paramsObject);
    if (Array.isArray(filters)) {
      filters.forEach(([filter, value]) => {
        const from = value.slice(0, 10);
        const to = value.slice(-10);
        return filter !== "seasons"
          ? params.append(filter, value)
          : (params.append("from", `${from}T00:00:00`),
            params.append("to", `${to}T23:59:59`));
      });
    }
    const res = await axiosProxy({
      url: `${url}`,
      params,
      method: "GET"
    });
    dispatch({
      type: actionTypes.SET_PICKER_REPORT_TABLE_LIST,
      payload: res.data
    });
    return res.data;
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_PICKER_REPORT_TABLE_LIST_FAILED,
      payload: error
    });
  }
};

export const fetchPickToPackPickerReportTableData = ({
  page,
  size,
  search,
  sort = ["id,desc"],
  unpaged = false,
  filters
}) => async dispatch => {
  try {
    dispatch({ type: actionTypes.FETCH_PICKER_REPORT_TABLE_DATA_START });
    const paramsObject = omitBy(
      {
        search,
        sort,
        page,
        size
      },
      isNil
    );
    const params = new URLSearchParams(paramsObject);

    if (Array.isArray(filters)) {
      filters.forEach(([filter, value]) => {
        const from = value.slice(0, 10);
        const to = value.slice(-10);
        return filter !== "seasons"
          ? params.append(filter, value)
          : (params.append("from", `${from}T00:00:00`),
            params.append("to", `${to}T23:59:59`));
      });
    }
    uniqId = uuid();

    const res = await axiosProxy({
      method: "GET",
      params,
      uniqId,
      url: `${url1}`
    });
    if (uniqId === res.config.headers["X-REQUEST-ID"]) {
      dispatch({
        type: actionTypes.FETCH_PICKER_REPORT_TABLE_DATA,
        payload: res.data
      });
    }
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_PICKER_REPORT_TABLE_DATA_FAILED,
      payload: error
    });
  }
};

export const fetchPickToPackPickerReportExportData = ({
  unpaged = true,
  filters
}) => async dispatch => {
  try {
    dispatch({
      type: actionTypes.FETCH_PICKER_REPORT_TABLE_LIST_START
    });
    const paramsObject = omitBy(
      {
        unpaged: true
      },
      isNil
    );
    const params = new URLSearchParams(paramsObject);
    if (Array.isArray(filters)) {
      filters.forEach(([filter, value]) => {
        const from = value.slice(0, 10);
        const to = value.slice(-10);
        return filter !== "seasons"
          ? params.append(filter, value)
          : (params.append("from", `${from}T00:00:00`),
            params.append("to", `${to}T23:59:59`));
      });
    }
    const res = await axiosProxy({
      url: `${url1}`,
      params,
      method: "GET"
    });
    dispatch({
      type: actionTypes.SET_PICKER_REPORT_TABLE_LIST,
      payload: res.data
    });
    return res.data;
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_PICKER_REPORT_TABLE_LIST_FAILED,
      payload: error
    });
  }
};
